import { capitalize } from './others/capitalize';

// Add a unique "key" field to each item in an array (for tables/lists)
export const addKeyInArray = (data: any) => {
  return data?.map(
    (el: object & { id?: string; _id?: string }, idx: number) => ({
      ...el,
      key: el?.id || el?._id || `${idx}`,
    }),
  );
};

export const countParPageSerialNumber = (
  page: number,
  limit: number,
  index: number,
) => {
  return index + 1 + (page - 1) * limit;
};

// utils/addSerial.ts
export const addUniqueKey = <T extends Record<string, any>>(
  data: T[],
  start = 1,
): (T & { sl: number; key: string })[] => {
  return data.map((item, index) => ({
    ...item,
    sl: start + index,
    key: item._id || `${start + index}-${Date.now()}-${Math.random()}`,
  }));
};

export const selectArrayOption = (
  data: any[],
  label: string,
  value: string | number,
  isCapitalLabel?: boolean,
) => {
  return data?.map((el) => ({
    label: isCapitalLabel ? capitalize(el[label]) : el[label],
    value: typeof value === 'number' ? Number(el[value]) : el[value] || null,
  }));
};
